import { Divider, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { FormAutoCompleteSelectDynamic } from "../../../../../components/hook-form/form-autocomplete-select.dynamic.component";
import { customersApiKeyStore } from "../../../../../api/customers-api-key-store";
import { officeApiKeyStore } from "../../../../../api/office-api-key-store";
import { projectsApiKeyStore } from "../../../../../api/projects-api-key-store";
import FormInput from "../../../../../components/hook-form/form-input.component";
import { FileUploadTextfield } from "../../../../../components/hook-form/file-upload-textfield.component";
import { FormSelectDynamic } from "../../../../../components/hook-form/form-select.dynamic.component";
import { planApiKeyStore } from "../../../../../api/plan-api-key-store";
import { FormAutoCompleteMultiSelectDynamic } from "../../../../../components/hook-form/form-autocomplete-multi-select.dynamic.component";
import { unitsApiKeyStore } from "../../../../../api/units-api-key-store";
import { extensionArray } from "../../../../../utils/extensions";



interface PlanRequestArgs {
    customerID?: number;
    projectID?: number;
    officeID?: number;
    unitID?: number;
}

interface CreatePlanForm {
    uploadFile: (file: File) => void;
    planRequestArgs?: PlanRequestArgs;
}

export const CreatePlanForm = ({ uploadFile, planRequestArgs }: CreatePlanForm) => {

    const { setValue, getValues } = useFormContext();

    const [enableFields, setEnableFields] = useState<boolean>(false);
    const [enableMultiFile, setEnableMultiFile] = useState<boolean>(false);
    const [enableReviewType, setEnableReviewType] = useState<boolean>(false);
    const [showArgs, updateArgs] = useState<any>({
        customerID: planRequestArgs ? planRequestArgs.customerID : 0,
        officeID: planRequestArgs ? planRequestArgs.officeID : 0,
        projectID: planRequestArgs ? planRequestArgs.projectID : 0,
        unitID: planRequestArgs ? planRequestArgs.unitID : 0,
    });

    const handleFileType = (fileTypeID: number) => {
        if (fileTypeID === 3) {
            setEnableFields(true);
            setEnableMultiFile(true);
        }
        else if (fileTypeID === 4 || fileTypeID === 5 || fileTypeID === 6) {
            setEnableFields(false);
            setEnableMultiFile(true);
            changedValues('fileList')
        }
        else {
            setEnableFields(false);
            setEnableMultiFile(false);
            changedValues()
        }
        if (fileTypeID) setEnableReviewType(true);
    }

    useEffect(() => {
        handleFileType(getValues('planFileTypeID'));
    }, [])

    const handelChangedValue = (type: string, value: any) => {
        updateArgs((prevState: any) => ({ ...prevState, [type]: value }));
    };

    const changedValues = (type?: string) => {
        setValue('sqFootage', '')
        setValue('volume', '')
        setValue('worstcaseScore', '')
        setValue('windowArea', '')
        if (type !== 'fileList') setValue('associatedPlan', { planID: '', planName: '' })
        setValue('wallHeight', '')
    }

    const handleFileUploadChange = (file: any) => {
        if (!file) {
            setValue('uploadedFile', null);
            setValue('uploadedFileType', null);
        }
        uploadFile(file);
    }

    return (
        <Grid container spacing={2}>
            <Grid item lg={12} sm={12} xl={12} xs={12}>
                <Grid container spacing={2}>
                    <Grid item lg={3} sm={3} xl={3} xs={3}>
                        <FormAutoCompleteSelectDynamic
                            name="customer"
                            label="Customer"
                            disabled
                            onChange={(value: any) => handelChangedValue('customerID', value?.customerID)}
                            getQueryKeyConfig={() => customersApiKeyStore.getCustomers()}
                            optionsValueKey="customerID"
                            optionsLabelKey="customerName"
                        />
                    </Grid>
                    <Grid item lg={3} sm={3} xl={3} xs={3}>
                        <FormAutoCompleteSelectDynamic
                            name="office"
                            label="Office"
                            disabled
                            watchKeys={['customer']}
                            onChange={(value: any) => handelChangedValue('officeID', value?.officeID)}
                            getQueryKeyConfig={() => officeApiKeyStore.getCustomerOffices(showArgs?.customerID)}
                            optionsValueKey="officeID"
                            optionsLabelKey="officeName"
                        />
                    </Grid>
                    <Grid item lg={3} sm={3} xl={3} xs={3}>
                        <FormAutoCompleteSelectDynamic
                            name="project"
                            label="Project"
                            disabled
                            watchKeys={['office']}
                            getQueryKeyConfig={() => projectsApiKeyStore.getOfficeProjects(showArgs?.officeID)}
                            optionsValueKey="projectID"
                            optionsLabelKey="projectName"
                        />
                    </Grid>
                    <Grid item lg={3} sm={3} xl={3} xs={3}>
                        <FormAutoCompleteSelectDynamic
                            name="unit"
                            label="Unit"
                            disabled
                            watchKeys={['project']}
                            getQueryKeyConfig={() => unitsApiKeyStore.getProjectUnits(showArgs?.projectID)}
                            optionsValueKey="unitID"
                            optionsLabelKey="unitName"
                        />
                    </Grid>
                </Grid>
            </Grid>
            <Grid item lg={12} sm={12} xl={12} xs={12}>
                <Grid container spacing={2}>
                    <Grid item lg={4} sm={4} xl={4} xs={4}>
                        <FormInput
                            label="Plan (or File) Name"
                            name="planName"
                            maxLength={150}
                        />
                    </Grid>
                    <Grid item lg={4} sm={4} xl={4} xs={4}>
                        <FileUploadTextfield
                            name="uploadedFile"
                            label='File Upload'
                            actionButton={true}
                            fileSizeTooptip
                            validate={extensionArray}
                            // validate={['PDF', 'DWF', 'DWFX', 'ENB']}
                            // errorMessage="Please Upload only PDF/DWF/DWFx/ENB file"
                            onChange={handleFileUploadChange}
                        />
                    </Grid>
                    <Grid item lg={4} sm={4} xl={4} xs={4}>
                        <FormSelectDynamic
                            name="planFileTypeID"
                            label="File Type"
                            onChange={handleFileType}
                            getQueryKeyConfig={() => planApiKeyStore.getPlanFileTypes()}
                            optionsValueKey="planFileTypeID"
                            optionsLabelKeys={['planFileTypeName']}
                        />
                    </Grid>
                </Grid>
            </Grid>
            {
                (enableFields || enableMultiFile || enableReviewType) && (<Grid item lg={12} sm={12} xl={12} xs={12}><Divider /></Grid>)
            }
            <Grid item lg={12} sm={12} xl={12} xs={12}>
                <Grid container spacing={2}>
                    {
                        enableFields && (
                            <>
                                <Grid item lg={3} sm={3} xl={3} xs={3}>
                                    <FormInput
                                        type="number"
                                        label="Area"
                                        name="sqFootage"
                                        disabled={!enableFields}
                                    />
                                </Grid>
                                <Grid item lg={3} sm={3} xl={3} xs={3}>
                                    <FormInput
                                        type="number"
                                        label="Volume"
                                        name="volume"
                                        disabled={!enableFields}
                                    />
                                </Grid>
                                <Grid item lg={3} sm={3} xl={3} xs={3}>
                                    <FormInput
                                        type="number"
                                        label="Worst Case Score"
                                        name="worstcaseScore"
                                        disabled={!enableFields}
                                    />
                                </Grid>
                                <Grid item lg={3} sm={3} xl={3} xs={3}>
                                    <FormInput
                                        type="number"
                                        label="Window Area"
                                        name="windowArea"
                                        disabled={!enableFields}
                                    />
                                </Grid>
                            </>
                        )
                    }
                    {
                        enableMultiFile && (
                            <Grid item lg={6} sm={6} xl={6} xs={6}>
                                <FormAutoCompleteSelectDynamic
                                    name="associatedPlan"
                                    label="Plan (or File) Name Associated With"
                                    disabled={!enableMultiFile}
                                    getQueryKeyConfig={() =>
                                        planApiKeyStore.getPlansByUnitAndForAssociation(showArgs.unitID, true)}
                                    optionsValueKey="planID"
                                    optionsLabelKey="planName"
                                />
                            </Grid>
                        )
                    }
                    {
                        enableFields && (
                            <Grid item lg={3} sm={3} xl={3} xs={3}>
                                <FormInput
                                    type="number"
                                    label="Wall Height"
                                    name="wallHeight"
                                    disabled={!enableFields}
                                />
                            </Grid>
                        )
                    }
                    {
                        enableReviewType && (
                            <Grid item lg={3} sm={3} xl={3} xs={3}>
                                <FormSelectDynamic
                                    name="planReviewTypeID"
                                    label="Document Relavance"
                                    getQueryKeyConfig={() => planApiKeyStore.getPlanReviewTypes()}
                                    optionsValueKey="planReviewTypeID"
                                    optionsLabelKeys={['planReviewTypeName']}
                                />
                            </Grid>
                        )
                    }
                </Grid>
            </Grid>
        </Grid>
    );
}